<template>
  <div class="control">
    <div class="control__title">
      <div class="title">
        <div class="title-text">
          {{ title }}
        </div>
        <div class="control__helper">
          <div class="control__trigger" @mouseover="showHint = true" @mouseleave="showHint = false">
            <img src="https://sirv.sirv.com/website/theme2/icon/question.svg" :alt="hint" />
          </div>
          <div
            v-show="showHint"
            class="hint"
            @mouseover="showHint = true"
            @mouseleave="showHint = false"
            v-html="hint"
          ></div>
        </div>
      </div>
    </div>
    <div class="control__action">
      <div class="control__choice">
        <div
          class="fakeoverlay"
          :class="{ disabled: !radioStatus }"
          @click="radioStatus = !radioStatus"
        />
        <el-radio
          v-for="(radioValue, index) in radioOption"
          :key="index"
          v-model="value"
          :disabled="!radioStatus"
          :label="radioValue.value"
          @change="changeOption"
        >
          {{ radioValue.value }}
        </el-radio>
      </div>
      <el-checkbox v-model="radioStatus" class="control__checkbox" @change="changeOption" />
    </div>
    <template v-if="value && value === 'Manual'">
      <div class="control__action" style="margin-top: 10px">
        <div class="control__choice">
          <div
            class="fakeoverlay"
            :class="{ disabled: !radioStatus }"
            @click="radioStatus = !radioStatus"
          />
          <el-input
            v-model="altInput"
            :placeholder="element.inputPlaceholder"
            @input="changeOption"
          ></el-input>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  name: "RadioInputAltImage",
  props: {
    title: {
      type: String,
      default: "",
    },
    default: {
      type: [Boolean, String],
      default: false,
    },
    hint: {
      type: String,
      default: "",
    },
    status: {
      type: Boolean,
    },
    options: {
      type: Array,
      default: Function,
    },
    parameter: {
      type: String,
      default: "",
    },
    element: {
      type: Object,
      default: () => {},
    },
    eventClick: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      value: this.default,
      radioStatus: this.status,
      radioOption: this.options,
      showHint: false,
      altInput: "",
    };
  },
  computed: {
    ...mapState(["clearOptions", "zoomEnable", "settings"]),
  },
  watch: {
    clearOptions(value) {
      if (value) {
        this.radioStatus = false;
        this.value = this.default;
        this.altInput = "";
      }
    },
    value(val) {
      if (val === "Auto" && this.altInput) {
        this.altInput = "";
      }
    },
    eventClick(val) {
      this.value = this.default;
      this.radioStatus = val;
      this.altInput = "";
    },
    radioStatus(val) {
      this.changeOption();
    },
  },
  methods: {
    changeOption() {
      const value = this.radioStatus === true ? `${this.value}` : "";
      this.$emit("changeOption", {
        parameter: `${this.parameter}`,
        separator: ":",
        value: `${value}|${this.altInput}`,
      });
    },
  },
};
</script>
